import styled from "styled-components";

let titleBarHeight = 100;

export const DeviceDetailsScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-position: center;
    background-size: cover;
    background-color: rgba(3, 19, 41, 0.918);
`;

export const DeviceDetailsScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
`;

export const DeviceDetailsBorderTop = styled.img`
    position: absolute;
    top: 12px;
    left: 12px;
    right:10px;
    width: 100%;
    height: 70px;
    z-index: 100;
`;

export const DeviceDetailsBorder= styled.img`
    position: absolute;
    top:0px;
    left: 2px;
    bottom: 0px;
    z-index: 80;
    //background-color:rgb(15, 53, 109);
    width: 99.2%;
    height: 100%;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 200;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const DeviceDetailsContent = styled.div`
    display: flex;
    position: absolute;
    //top: calc(${titleBarHeight}px);
    top: 75px;
    width: 100%;
    height: calc(100% - 75px);
    padding: 5px 20px;
    overflow-x: visible;
    overflow-y: visible;
    //grid-template-columns: 2fr 3fr 2fr;
    //grid-template-rows: 1fr 5fr;
    //grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    z-index: 100;
`;

export const DetailsDetailsAndMapWrapper = styled.div`
    z-index: 100;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const DeviceDetailsWrapper = styled.div`
    z-index: 100;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 0 0 auto;
`;

export const DeviceTrackWrapper = styled.div`
    width: 100%;
    flex: 1 1 auto;
    box-sizing: border-box;
`;

export const DeviceModel3DWrapper = styled.div`
    /* render behind cards and allow canvas to overflow into adjacent grid cells */
    z-index: 50;
    overflow: visible;
    //grid-column: 1 / 3;
    //grid-row: 2 / 3;
    width: 90%;
    height: 100%;
    align-items: stretch;
    margin-top: auto;

    background-image: url(/static/images/big-screen/v2/3d-model-background.png) ;
    background-repeat: no-repeat;
    background-size: 100% 80%; 
    background-position: center center;
`;



export const DeviceRealtimeMetricsWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    z-index: 100;
    box-sizing: border-box;
`;

export const AlarmToggleBox = styled.div`
    position: absolute;
    left: 20px;
    bottom: 20px;
    z-index: 300;
    width: 32px;
    height: 96px;
    background-color:rgba(14, 17, 39, 0.774);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    box-shadow: 0 0 6px rgba(0,0,0,0.4);
    border: 2px solid rgba(95, 112, 150, 0.3);
`;

export const AlarmToggleText = styled.div`
    writing-mode: vertical-rl;
    text-orientation: upright;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 4px;
    user-select: none;
`;


